import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {BottomPage} from '../../../clean-components/bottom-page/bottom-page';
import {BackHomeButton} from '../../../components/buttons/backHome-button/backHome-button';
import {CloseMarkers} from '../../../clean-components/close-markers/close-markers';

export function CloseServicesMobile() {
    const location = useLocation();

    useEffect(() => {
        document.getElementsByClassName('header')[0].classList.add('hide');
        document.getElementsByClassName('transports-button')[0].classList.add('hide');
    }, [location]);

    return <>
        <BackHomeButton/>
        <BottomPage maximizedOnCreate={true} medium={true}>
            <CloseMarkers/>
        </BottomPage>
    </>;
}
